// TODO: we need a type expert here so we won't have to ignore the lines
// TODO: use it everywhere (static function; export from which file? <-- global Window typing required)
export function isInstance(node, constr) {
    const doc = node.ownerDocument;
    if (!doc) { // null if Document
        return constr.name === 'Document';
    }
    let context = 
    // @ts-ignore (for EI, Safary)
    doc.parentWindow ||
        doc.defaultView; // TODO: smart global typing for Window object
    while (context.parent && context.parent !== context) {
        // @ts-ignore
        if (node instanceof context[constr.name]) {
            return true;
        }
        // @ts-ignore
        context = context.parent;
    }
    // @ts-ignore
    return node instanceof context[constr.name];
}
export function inDocument(node) {
    const doc = node.ownerDocument;
    if (!doc) {
        return false;
    }
    if (doc.contains(node)) {
        return true;
    }
    let context = 
    // @ts-ignore (for EI, Safary)
    doc.parentWindow ||
        doc.defaultView;
    while (context.parent && context.parent !== context) {
        if (context.document.contains(node)) {
            return true;
        }
        // @ts-ignore
        context = context.parent;
    }
    return false;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@openreplay/tracker/lib/app/context.js
// module id = 579
// module chunks = 0